import { render } from "./AdvertisementModal.vue?vue&type=template&id=a999a6b8"
import script from "./AdvertisementModal.vue?vue&type=script&lang=js"
export * from "./AdvertisementModal.vue?vue&type=script&lang=js"

import "./AdvertisementModal.vue?vue&type=style&index=0&id=a999a6b8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__